import { HttpClient } from '../../../httpClient'
import { OpalApiRequestParams } from '../../../schema'

interface DeleteBlockConnectorArguments {
  params: OpalApiRequestParams<'DeleteBlockConnectorV3'>
}

export async function deleteBlockConnector({
  params,
}: DeleteBlockConnectorArguments): Promise<null> {
  const url = new URL(
    `/loupe/v3/block_connectors/${params.path.block_connector_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
